import axios from '@/axios'
import { getBackToPharmacyValue } from '@/utils/backToPharmacy'

export async function getOrderInfo(orderId, timestamp) {
  const tValue = timestamp != null ? timestamp : ''
  const response = await axios.get(`order/${orderId}/info`, {
    params: { t: tValue },
  })
  return response.data
}

export async function confirmDelivery(orderId, request) {
  const response = await axios.post(`order/${orderId}/confirm-delivery`, request)
  return response.data
}

export async function uploadSign(orderId, request) {
  const response = await axios.post(`order/${orderId}/upload-sign`, request)
  return response.data
}

export async function updateSpecialInstruction(orderId, request) {
  const response = await axios.post(`order/${orderId}/update-instructions`, request)
  return response.data
}

export async function orderUpdated(orderId, orderData) {
  const request = {
    status: orderData.status,
    // Легаси: старый api сравнивает только sub_status.
    sub_status: orderData.sub_status,
    activity: orderData.activity,
    confirmed: orderData.confirmed,
    // SCRUM-3980: api сравнивает свойство, если ключ прислан; undefined (api без поля) в JSON не уходит.
    back_to_pharmacy: getBackToPharmacyValue(orderData),
  }
  const response = await axios.post(`order/${orderId}/order-updated`, request)
  return response.data
}
